module.exports = __webpack_public_path__ + "static_pc/img/ower03.6651ade2.png";